import React from 'react';
import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';
import { ClientPhotoPurpose } from '@common/model/client/photo/purpose';
import { Stack } from '@cp/ds/src/components/stack';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { CameraIcon, EyeIcon } from '@cp/ds/src/icons';
import { CareerTag } from '@cp/entities/career';
import { ClientPhotoCard } from '@cp/entities/clientPhoto';
import { NotificationSubscriptions, SchoolYouHelpTag } from 'src/entities/client';
import { ProfileDates } from 'src/entities/resume';
import { ProfileModerationToggles } from 'src/features/moderation/profileToggles';

export interface SpecialistPhotosSectionProps {
  clientProfile?: AdminClientProfileViewModel;
  resumePhotoData: Parameters<typeof ClientPhotoCard>[0]['data'];
  avatarPhotoData: Parameters<typeof ClientPhotoCard>[0]['data'];
  onResumePhotoClick: () => void;
  onAvatarPhotoClick: () => void;
  onAiGenerateClick: () => void;
  onImpersonateClick?: () => void;
  isImpersonateLoading?: boolean;
}

export const SpecialistPhotosSection: React.FC<SpecialistPhotosSectionProps> = ({
  clientProfile,
  resumePhotoData,
  avatarPhotoData,
  onResumePhotoClick,
  onAvatarPhotoClick,
  onAiGenerateClick,
  onImpersonateClick,
  isImpersonateLoading,
}) => {
  return (
    <Stack direction="row" gap={3} sx={{ alignItems: 'flex-start', width: 1 }}>
      <ClientPhotoCard data={resumePhotoData} onClick={onResumePhotoClick} size={361} sx={{ flexShrink: 0 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, minWidth: 0 }}>
        <Stack direction="row" gap={1} sx={{ alignItems: 'flex-start' }}>
          <ClientPhotoCard data={avatarPhotoData} onClick={onAvatarPhotoClick} size={160} sx={{ flexShrink: 0 }} />
          <Button color="white" onClick={onAiGenerateClick} size="small" square variant="primary">
            <CameraIcon />
          </Button>
          {onImpersonateClick ? (
            <Button
              aria-label="Войти под пользователем"
              color="white"
              disabled={isImpersonateLoading}
              onClick={onImpersonateClick}
              size="small"
              square
              title="Войти под пользователем"
              variant="primary"
            >
              <EyeIcon />
            </Button>
          ) : null}
        </Stack>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {clientProfile?.notificationPlatforms?.length ? (
            <NotificationSubscriptions data={clientProfile.notificationPlatforms} />
          ) : null}
          {clientProfile?.mainCareerId ? <CareerTag careerId={clientProfile.mainCareerId} /> : null}
          <SchoolYouHelpTag trainingCompletedAt={clientProfile?.trainingCompletedAt} />
        </Box>
        <ProfileDates createdAt={clientProfile?.createdAt} lastActivityAt={clientProfile?.lastActivityAt} />
        <ProfileModerationToggles clientProfile={clientProfile} variant="compact" />
      </Box>
    </Stack>
  );
};

export { ClientPhotoPurpose };
